import React from 'react'
import { get } from 'lodash'

import connect from '~/tools/connect'
import popup from './popup'
import store from './redux'
import userStore from '~/redux/user/store';
import './style.css'

import Login from './views/Login'
import ForgotPassword from './views/ForgotPassword'
import Search from './views/Search'
import SearchList from './views/SearchList'
import error from './views/error'
import EpisodeOverlay from './views/EpisodeOverlay'

import Purchase from './views/Purchase'

import CreateSubscription from './views/CreateSubscription'
import CancelSubscription from './views/CancelSubscription'
import BillingHistory from './views/BillingHistory'
import UpgradeSubscription from './views/UpgradeSubscription'
import UpdateStripePayment from './views/UpdateStripePayment'

import UpdateProfile from './views/UpdateProfile'
import ChangePassword from './views/ChangePassword'
import ManageDevices from './views/ManageDevices'
import Notice from './views/Notice'

import Equipment from './views/Equipment'

import CustomOverlay from './views/CustomOverlay'

import FitnessSignInCreate from './views/FitnessOnboarding/SignInCreate';
import FitnessChooseAPlan from './views/FitnessOnboarding/ChooseAPlan';
import FitnessCheckout from './views/FitnessOnboarding/Checkout';
import FitnessSetupProfile from './views/FitnessOnboarding/SetupProfile';
import FitnessOnboardingScreen from './views/FitnessOnboarding/OnboardingScreen';
import LoginEmailPassword from './views/LoginEmailPassword'
import ProviderList from './views/ProviderList'
import NewsLogin from './views/NewsLogin';
import NewsForgotPassword from './views/NewsForgotPassword';
import newsEpisodeOverlay from './views/NewsEpisodeOverlay';
import PinOverlay from './views/PinOverlay'
import ThankYou from './views/ThankYou'

import WorkoutEpisodeOverlay from './views/WorkoutEpisodeOverlay';

import Personalization from './views/Personalization';
import VerifyOTP from './views/VerifyOTP'
import UpdateNumber from './views/UpdateNumber'
import Cookies from 'js-cookie'

import ViewingRestrictions from './views/ViewingRestrictions'
import { enableNonModalTabbing, disableNonModalTabbing } from '~/tools/dom/accessibility'
import SetupPin from './views/setupPin'
import PasswordAuth from './views/setupPin/passwordAuth'
import ideal from './views/ideal'

var componentMap = {
  login: Login,
  newsLogin: NewsLogin,
  forgotPassword: ForgotPassword,
  newsForgotPassword: NewsForgotPassword,
  cancelSubscription: CancelSubscription,
  upgradeSubscription: UpgradeSubscription,
  updateStripePayment: UpdateStripePayment,
  billingHistory: BillingHistory,
  search: Search,
  error: error,
  createSubscription: CreateSubscription,
  updateProfile: UpdateProfile,
  changePassword: ChangePassword,
  manageDevices: ManageDevices,
  notice: Notice,
  EpisodeOverlay: EpisodeOverlay,
  newsEpisodeOverlay: newsEpisodeOverlay,
  purchase: Purchase,
  equipment: Equipment,
  customOverlay: CustomOverlay,
  searchList: SearchList,
  fitnessOnboardingScreen: FitnessOnboardingScreen,
  fitnessSignInCreate: FitnessSignInCreate,
  fitnessChooseAPlan: FitnessChooseAPlan,
  fitnessCheckout: FitnessCheckout,
  fitnessSetupProfile: FitnessSetupProfile,
  persolizationSetUpProfile: Personalization,
  providerList:ProviderList,
  workoutEpisodeOverlay: WorkoutEpisodeOverlay,
  viewingRestrictions: ViewingRestrictions,
  setupPin: SetupPin,
  pinOverlay: PinOverlay,
  passwordAuth: PasswordAuth,
  verifyOTPScreen: VerifyOTP,
  updateNumber: UpdateNumber,
  loginEmailPassword: LoginEmailPassword,
  thankYou: ThankYou,
  ideal: ideal
};

class View extends React.Component {
  constructor() {
    super()
    this.state = { refresh: null, customStyle: {} }
  }

  componentDidMount() {
    window.addEventListener('keydown', e => (e.keyCode === 27) && popup.hide())
  }

  updateCustomStyle(newCustomStyle){
    this.setState({customStyle: newCustomStyle})
  }
  
  shouldComponentUpdate(nextProps, nextState){
    const onViewPlansPage = window.location.href.includes("plans")
    if (onViewPlansPage && get(this.state, 'user.isSubscribed') && nextState.show === "hide"){
      window.location.href = '/'
      return false;
    }
    return true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.show === 'purchase' && this.state.show === 'EpisodeOverlay') {
      this.watchNow = true
    }

    // clear previous custom style for new popup
    if (Object.keys(prevState.customStyle).length !== 0 && prevState.show !== this.state.show){
      this.setState({customStyle:{}});
    }

    const refreshScreen = () => {
      if (this.state.refresh) {
        this.state.refresh()
      }
    }

    // refresh screen after 1. purchase has been completed and user closes overlay 
    // or 2. user goes to watch now, and then closes the overlay
    if (prevState.show === 'purchase' && this.state.show === 'hide') {
      refreshScreen()
    } else if (this.watchNow) {
      if (prevState.show === 'EpisodeOverlay' && this.state.show === 'hide') {
        refreshScreen()
        this.watchNow = false
      }
    }
  }

  render() {
    var setAppState = this.setState.bind(this)
    const { args, user, refresh } = this.state

    var MyComponent = componentMap[this.state.show]
    this.bodyHack(!!MyComponent)
    
    if (!MyComponent) {
      enableNonModalTabbing()
      return <div />
    }
    
    disableNonModalTabbing()
    
    const renderCloseButton = (args.showCloseButton === undefined) ? true : args.showCloseButton
    const hideCloseButton = Cookies.get('isiDealPayment') ? true : false
    return (
      <div className={ `popup-view` } style={this.state.customStyle}>
        <MyComponent 
          args={args} 
          user={user} 
          refresh={refresh} 
          setAppState={setAppState}
          onClose={ popup.hide }
          updateCustomStyle = {this.updateCustomStyle.bind(this)}
        />
        {
          renderCloseButton && !hideCloseButton &&
          <button aria-label="Close Modal" type="button" className={"close " + (this.state.show === 'searchList' ? 'searchList' : '')} onClick={(evts)=>{
            args.redirectUrl? (window.location = args.redirectUrl) : popup.hide()
            if(!Cookies.get('isJusPayThankYou')){
              if(Cookies.get('isUserSignUp') && Cookies.get('isThankYouPage') && Cookies.get('isUserSignUp').match('true') && Cookies.get('isThankYouPage').match('true') && window.settings.recommendation && window.settings.recommendation.isRecommendation && window.settings.recommendation.isPersonalization && window.settings.recommendation.recommendCategories && window.settings.recommendation.recommendCategories.length>0)
                popup.persolizationSetUpProfile() && Cookies.set('isUserSignUp', false) &&  Cookies.set('isThankYouPage', false);
            }
          }}>
          <i role="presentation" className="ion-ios-close-empty" />
        </button>
          
        }
      </div>
    )
  }

  bodyHack(shown) {
    const bcl = window.document.body.classList
    if (!bcl) 
      return

    if (shown) {
      bcl.add('overflow-hide')
    } else if (bcl.contains('overflow-hide')) {
      bcl.remove('overflow-hide')
    }
  }
}


connect(View, (state) => ({ user: state.user }), userStore)
connect(View, (state) => ({ show: state.show, args: state.args || {} }), store)
export default View
